import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Radium from "radium";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import Pagination from "./Pagination";
import Loader from "../../Shared/Loader";
import {
  searchProfiles as searchProfilesAction,
  getProfiles as getProfilesAction,
  setProfileIndex as setProfileIndexAction,
} from "../../../redux/middleware/profile";
import { getSubscriptions as getSubscriptionsAction } from "../../../redux/middleware/subscription";
import {
  getProfiles,
  getProfilesError,
  getProfilesPending,
  getProfilesFilters,
  getProfilesTotal,
  getProfileIndex,
} from "../../../redux/reducers/profile";

import Filter from "./Filter";
import ProfileRow from "./ProfileRow";
import DocumentViewer from "./DocumentViewer";
import Utils from "../../../lib/utils";
import { LinkButton } from "../../Subscriptions/Banner/index.style";

const styles = {
  h1: {
    fontSize: 24,
    fontFamily: "Raleway",
    color: "#0a3949",
    fontWeight: 700,
  },
  button: {
    margin: "15px 0 0 0",
    color: "#fff",
    padding: "12px 25px",
  },
  p: {
    fontFamily: "Raleway",
    width: "100%",
    float: "left",
    margin: "0 0 20px 0",
    padding: 0,
    fontSize: 16,
    color: "#8290a2",
    fontWeight: 500,
  },
};

const ProfileListContainer = styled(Grid)`
  width: 100vw;
  #resume-details {
    position: -webkit-sticky;
    position: sticky;
    top: 5rem;
  }
`;

const Resume = styled.div`
  background: #dfe1e4;
  position: absolute;
`;

const Profiles = ({ profiles, subscribed }) => {
  if (!profiles) return <p>No Profiles found.</p>;
  return (
    <div>
      {profiles.map((profile) => {
        return (
          <ProfileRow
            profile={profile}
            key={profile.id}
            subscribed={subscribed}
          />
        );
      })}
    </div>
  );
};

const Subscribe = () => {
  const MessageContainer = styled.div`
    display: grid;
    place-content: center;
    height: 80vh;

    h2 {
      font-size: 3rem;
    }
  `;

  const Button = styled(LinkButton)`
    place-self: center;
  `;
  return (
    <MessageContainer>
      <h2> Kindly subscribe to view profiles </h2>
      <Button href="/subscriptions"> Subscribe </Button>
    </MessageContainer>
  );
};

class ProfileList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProfiles: [],
      currentPage: 1,
      totalPages: null,
      filterLoader: false,
      stateFilters: [],
      defaultPageLimit: 20,
    };
  }

  componentWillMount() {
    const { getSubscriptions, setProfileIndex } = this.props;
    this.searchProfiles();
    getSubscriptions();
    setProfileIndex({ profileIndex: 0 });
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props;
    const { stateFilters, currentPage, defaultPageLimit } = this.state;
    if (
      location.pathname !== nextProps.location.pathname ||
      location.search !== nextProps.location.search
    ) {
      this.searchProfiles();
    }
    if (stateFilters && stateFilters.length <= 1) {
      this.setState({ stateFilters: nextProps.filters });
    }
    this.setState({ currentProfiles: nextProps.profiles });

    this.onPageChanged({
      currentPage,
      totalPages: nextProps.profiles.length,
      pageLimit: defaultPageLimit,
      profiles: nextProps.profiles,
    });
  }

  searchProfiles = (filters = null) => {
    const { searchProfiles } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const keywords = urlParams.get("keywords") || "";
    const location = urlParams.get("location") || "";
    searchProfiles(Utils.constructSearchUrl(keywords, location, filters));
    if (filters) this.setState({ filterLoader: true });
  };

  onPageChanged = (data) => {
    const { currentPage, totalPages, pageLimit, profiles } = data;
    if (profiles) {
      let newcurrentPage = currentPage;
      if (currentPage === 0) {
        newcurrentPage = 1;
      }

      const offset = (newcurrentPage - 1) * pageLimit;
      const currentProfiles = profiles.slice(offset, offset + pageLimit);
      this.setState({ currentPage, currentProfiles, totalPages });
    }
  };

  renderdoc = (currentProfiles) => {
    const { profileIndex } = this.props;
    const resume =
      currentProfiles[profileIndex] && currentProfiles[profileIndex].resume;

    if (resume) {
      return (
        <DocumentViewer
          styles={{ backgroundColor: "rgba(206, 206, 206)" }}
          hide={false}
          content={resume.content}
          show
        />
      );
    }

    return (
      <DocumentViewer
        styles={{ backgroundColor: "rgba(206, 206, 206)" }}
        hide={false}
        content="No Resume Available"
        show
      />
    );
  }

  render() {
    const { profiles, pending, userSubscription } = this.props;
    const {
      currentProfiles,
      defaultPageLimit,
      stateFilters,
      filterLoader,
    } = this.state;
    if (pending && !filterLoader) return <Loader fullScreen show />;

    const totalSearchedProfiles = profiles.length;
    if (totalSearchedProfiles === 0) return null;
    return (
      <div style={{ background: "#dfe1e4" }}>
        <ProfileListContainer id="profile-list">
          <Row style={{ background: "#fff" }}>
            <Col md={2} style={{ background: "#fff" }}>
              <Filter
                filters={stateFilters}
                search={(filters) => this.searchProfiles(filters)}
              />
            </Col>
            <Col md={4} className="clearfix" style={{ background: "#fff" }}>
              <div>
                <Pagination
                  totalRecords={totalSearchedProfiles}
                  pageLimit={defaultPageLimit}
                  pageNeighbours={10}
                  onPageChanged={this.onPageChanged}
                />
              </div>
              <Row>
                <Col xs={5} sm={7} md={8} lg={8} className="clearfix">
                  <div className="animated flipInX">
                    <h1 style={styles.h1} className="">
                      All Profiles
                    </h1>
                    <p style={styles.p} className="hidden-xs">
                      Displaying {currentProfiles.length} out of{" "}
                      {totalSearchedProfiles} profiles
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="clearfix" style={{ top: -10, marginBottom: 60 }}>
                <Col lg={12} className="clearfix">
                  <Profiles
                    profiles={currentProfiles}
                    subscribed={
                      userSubscription && userSubscription.status === "active"
                    }
                  />
                </Col>
              </Row>
              <div className="">
                <Pagination
                  totalRecords={totalSearchedProfiles}
                  pageLimit={defaultPageLimit}
                  pageNeighbours={10}
                  onPageChanged={this.onPageChanged}
                />
              </div>
            </Col>
            {userSubscription && userSubscription.status === "active" ? (
              <Col
                id="resume-details"
                md={6}
                className="clearfix hidden-xs"
                style={{
                  position: "sticky",
                  margin: 0,
                  padding: 0,
                  background: "#dfe1e4",
                }}
              >
                <Resume>{this.renderdoc(profiles)}</Resume>
              </Col>
            ) : (
              <Subscribe />
            )}
          </Row>
        </ProfileListContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getProfilesError(state),
  profiles: getProfiles(state),
  pending: getProfilesPending(state),
  filters: getProfilesFilters(state),
  totalProfiles: getProfilesTotal(state),
  profileIndex: getProfileIndex(state),
  userSubscription: state.subscription.userSubscription,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      searchProfiles: searchProfilesAction,
      setProfileIndex: setProfileIndexAction,
      getSubscriptions: getSubscriptionsAction,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Radium(withRouter(ProfileList)));
